export default "__VITE_ASSET__dzbv5nrL__"